import React, { Component } from "react";
import { Row, Col, Button, Form, Select, message, Input, Checkbox } from "antd";
import { withRouter } from "react-router-dom";
import { API } from "../../../API/API";
const { TextArea } = Input;
class JoinWorkProductReq extends Component {
  formRef = React.createRef();
  state = {
    joinworkid: this.props.joinworkid,
    productreq: localStorage.getItem('productreq') ? localStorage.getItem('productreq') : this.props.joinworkproductreq,
    ownersupply:localStorage.getItem('ownersupply') ? localStorage.getItem('ownersupply') : this.props.joinworkownersupply,
    isEdit: this.props.isEdit,
    dkey: 1,
  };

// #*****************
  onChangeValue = (name, value) => {
    this.setState({ [name]: value });
  };

  buildRequestBody = () => {
    const { joinworkid, productreq, ownersupply } = this.state;
    return {
      joinworkid, products_requirements: productreq, owners_product_supply: ownersupply
   };
  }

  saveJoinWorkProductRequirement = async (body) => {
    try {
      const response = await API.post("/saveJoinWorkProductRequirement", body);
      if (response.status === 200) {
        message.success("Амжилттай хадгаллаа.");
      }
    } catch (error) {
      console.log("error=", error)
      message.error("Хадгалалт амжилтгүй боллоо.");
    }
  };

  onSave = () => {
    const { joinworkid, productreq, ownersupply } = this.state;
    const body = this.buildRequestBody();
    
    this.saveJoinWorkProductRequirement(body);
    localStorage.setItem('joinworkid', joinworkid);
    localStorage.setItem('productreq', productreq);
    localStorage.setItem('ownersupply', ownersupply);
  };
// #***************** 
  render() {
    return (
      <div id="criteria" key={this.state.dkey}>
        <Form
          className="formDrawer"
          ref={this.formRef}
          onFinish={this.onSubmit}
          layout="vertical"
          initialValues={{}}
        >
          <Row gutter={[16, 16]}><Col><div className="HeaderLabel">3. Бараанд тавигдах шаардлага, Захиалагчийн нийлүүлэх бараа</div></Col></Row>
          <Row gutter={[16, 16]} style={{paddingTop:10}}>
            <Col span={24}>
              <Form.Item
                label="Бараанд тавигдах шаардлага"
                name="productreq"
                initialValue={this.state.productreq}
              >
                <TextArea
                  onChange={(e) => this.onChangeValue("productreq", e.target.value)}
                  rows={5}
                  value={this.state.address}
                  disabled={this.state.isEdit ? false : true}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                label="Захиалагчийн нийлүүлэх бараа, үйлчилгээ"
                name="ownersupply"
                initialValue={this.state.ownersupply}
              >
                <TextArea
                  onChange={(e) => this.onChangeValue("ownersupply", e.target.value)}
                  rows={8}
                  value={this.state.ownersupply}
                  disabled={this.state.isEdit ? false : true}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col>
              <Form.Item className="buttonForm" style={{marginTop: '5px'}}>
                <Button type="primary" className="btnPrimary" htmlType="submit" disabled={this.state.isEdit ? false : true}
                  onClick={this.onSave}>Барааны шаардлага Хадгалах
                </Button>
             </Form.Item>
            </Col>
          </Row>   
        </Form>
      </div>
    );
  }
}
export default withRouter(JoinWorkProductReq);
